import React from 'react'
import Img from 'gatsby-image'
import Hero from '../components/homepage/hero/'
import InfoBlock from '../components/shared/infoBlock'
import ArrowButton from '../components/shared/arrowButton'
import get from 'lodash/get'
import Carousel from '../components/shared/Carousel'
import CourseValue from '../components/homepage/courseValues/courseValue'
import { Default, Tablet, Mobile } from '../media-queries'
import Universities from '../components/homepage/universities'
import Family from '../components/homepage/family'
import './index.css'
import CourseValues from '../components/homepage/courseValues'
import AngleBracketButton from '../components/shared/angleBracketButton'
import WWAnimation from '../components/homepage/worldwideAnimation'

class IndexPage extends React.Component {
  render() {
    const [dataNode] = get(this, 'props.data.allContentfulHomepage.edges')
    const data = dataNode.node

    return (
      <div
        style={{
          fontFamily: "'Libre Franklin', 'sans serif'",
        }}
      >
        <Default>
          <DefaultIndexPage data={data} />
        </Default>
        <Mobile>
          <MobileIndexPage data={data} />
        </Mobile>
      </div>
    )
  }
}

export default IndexPage

const DefaultIndexPage = ({ data }) => (
  <div
    className="scroll-container"
    style={{
      background: '#f7f7f7',
    }}
  >
    <Hero
      image={data.heroImage}
      title={data.heroTitle}
      text={data.heroText.internal.content}
    />
    <Universities
      title={data.header1}
      text={data.courseDescription.internal.content}
    />
    <CourseValues
      image={data.learningOutcomesBackground}
      data={data.learningOutcomes}
    />
    <Family
      title={data.header2}
      prospectives={data.prospectives}
      image={data.closingImage}
    />
  </div>
)

const MobileIndexPage = ({ data }) => (
  <div>
    <Hero
      image={data.heroImage}
      title={data.heroTitle}
      text={data.heroText.internal.content}
    />
    <WWAnimation style={{ marginBottom: '-6rem', marginLeft: '1.5rem' }} />
    <div style={{ backgroundColor: '#F7F7F7', paddingTop: '2rem' }}>
      <InfoBlock
        style={{
          paddingTop: '3rem',
          paddingBottom: '3rem',
          marginLeft: '2rem',
          marginRight: '2rem',
          marginTop: '2rem',
        }}
        title={data.header1}
        text={data.courseDescription.internal.content}
      >
        <AngleBracketButton
          hasCaret={false}
          link={'/programme'}
          style={{
            width: '204px',
            background: '#8CBD8C',
            margin: '2.25rem auto 2rem',
          }}
          text={'Our Programme'}
        />
      </InfoBlock>
      <div
        style={{
          background:
            'linear-gradient(to bottom, #F7F7F7, #F7F7F7 20%, #8CBD8C 20%, #8CBD8C)',
          paddingBottom: '1rem',
        }}
      >
        <Carousel title="Carousel" autoProgress={true}>
          {data.learningOutcomes.map(outcome => (
            <CourseValue
              key={outcome.value}
              img={outcome.image}
              title={outcome.value}
              text={outcome.text.internal.content}
            />
          ))}
        </Carousel>
        <ArrowButton
          style={{ ...arrowMargins, marginRight: '2rem' }}
          route="/learning-outcomes-and-course-content"
          text="Read more about IMRD"
        />
      </div>
    </div>
    <InfoBlock
      style={{
        paddingTop: '3rem',
        marginLeft: '2rem',
        marginRight: '2rem',
        paddingBottom: '3rem',
      }}
      title={data.header2}
      text={data.prospectives.internal.content}
    >
      <ArrowButton
        style={arrowMargins}
        route="/student-stories"
        text="Read our students' stories"
      />
    </InfoBlock>
    <Img sizes={data.closingImage.sizes} />
  </div>
)
const arrowMargins = {
  marginTop: '3rem',
  marginBottom: '1rem',
}

export const homepageQuery = graphql`
  query Homepage {
    allContentfulHomepage {
      edges {
        node {
          heroImage {
            sizes(maxWidth: 1920) {
              ...GatsbyContentfulSizes
            }
          }
          heroTitle
          heroText {
            internal {
              content
            }
          }
          header1
          courseDescription {
            internal {
              content
            }
          }
          learningOutcomes {
            value
            image {
              sizes(maxWidth: 900) {
                ...GatsbyContentfulSizes
              }
            }
            text {
              internal {
                content
              }
            }
          }
          learningOutcomesBackground {
            sizes(maxWidth: 1920) {
              ...GatsbyContentfulSizes
            }
          }
          header2
          prospectives {
            internal {
              content
            }
          }
          closingImage {
            sizes(maxWidth: 1280) {
              ...GatsbyContentfulSizes
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js